import { Injectable } from '@angular/core';


@Injectable()
export class RestrictOutsideScrollService {

    constructor() { }

    hideBackgroundScroll() {
		document.querySelector('body').classList.add('body-overflow-hidden');
	}

	showBackgroundScroll() {
		if (document.querySelector('body').classList.contains('body-overflow-hidden')) {
			document.querySelector('body').classList.remove('body-overflow-hidden');
		}
	}
}